module.exports = __webpack_public_path__ + "/build/web/images/logos/budget-blinds/budget-blinds@2x.47f3c0b9e59bb2149e9c574c6a02c785.png";


//////////////////
// WEBPACK FOOTER
// ./images/logos/budget-blinds/budget-blinds@2x.png
// module id = 161
// module chunks = 13